import ApiDatabase from "../server";

export const fetchTimeCut = () => {
  return new Promise((resolve, reject) => {
    ApiDatabase.getTimeCut(
      {},
      (res) => resolve(res),
      (err) => reject(err)
    );
  });
};

export const updateTimeCut = (newValue) => {
  return new Promise((resolve, reject) => {
    ApiDatabase.postUpdateTimeCut(
      { timeCut: newValue },
      (res) => resolve(res),
      (err) => reject(err)
    );
  });
};

export const fetchBreaks = () => {
  return new Promise((resolve, reject) => {
    ApiDatabase.getBreaks(
      {},
      (res) => resolve(res),
      (err) => reject(err)
    );
  });
};

export const updateBreaks = (selectedBreak) => {
  return new Promise((resolve, reject) => {
    ApiDatabase.postUpdateBreaks(
      { breaks: selectedBreak },
      (res) => resolve(res),
      (err) => reject(err)
    );
  });
};

// Fetches whether PDNS display is enabled for the big company
export const fetchPdnsDisplay = () => {
  return new Promise((resolve, reject) => {
    ApiDatabase.getPdnsDisplay(
      {},
      (res) => resolve(res),
      (err) => reject(err)
    );
  });
};

// Fetches list of companies with their PDNS status
export const fetchCompaniesPdns = () => {
  return new Promise((resolve, reject) => {
    ApiDatabase.getCompaniesPdns(
      {},
      (res) => resolve(res),
      (err) => reject(err)
    );
  });
};

// Updates PDNS setting for a specific company
export const updateCompanyPdns = (idCompany, isPdns) => {
  return new Promise((resolve, reject) => {
    ApiDatabase.postUpdateCompanyPdns(
      { idCompany, isPdns },
      (res) => resolve(res),
      (err) => reject(err)
    );
  });
};
